import {
  IRequestTravel,
  IRequestTravelData,
  RequestTravelStatus
} from './index'
import {
  Category,
  ITravelBase,
  TravelBase
} from '../../../index'


export class RequestTravel extends TravelBase implements IRequestTravel {
  // id, name, price
  readonly travel?: ITravelBase
  readonly status: RequestTravelStatus
  readonly category?: Category
  readonly is_private: boolean
  readonly stripe_product: string
  readonly stripe_price: string

  constructor(data: IRequestTravelData) {
    super(data)
    const travel = data.travel
    this.travel = travel ? new TravelBase(travel) : undefined
    this.status = data.status || 'new'
    this.category = data.category
    this.is_private = data.is_private || false
    this.stripe_price = data.stripe_price
    this.stripe_product = data.stripe_product
  }

  validate(): boolean {
    return super.validate();
  }

  update(data?: IRequestTravelData): void {
    super.update(data)
    const travelData = data?.travel
    const travel = this.travel
    if (travel && travelData) {
      travel.update(travelData);
    }
  }

}
